import React, { useState, useEffect } from 'react';
import './AdjustPriceModal.css';
import api from '../../../seller-apis/api';
import { useAlert } from 'react-alert';

const AdjustPriceModal = ({
  isOpen,
  onClose,
  productData = {},
  receivedFrom
}) => {
  const [newPrice, setNewPrice] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const alert = useAlert();

  useEffect(() => {
    if (isOpen && productData?.lowestPrice) {
      setNewPrice(productData?.lowestPrice);
    }
  }, [isOpen, productData]);

  const handleUpdatePrice = async () => {

    if (newPrice === 0) {
      alert.info("Price cannot be 0.");
      return;
    }
    setIsLoading(true);
    try {
      let data;
      if (productData?.foundCombination || (productData?.urlKey && productData?.attributeValue !== "")) {
        let url = productData?.foundCombination ? productData?.foundCombination?.url : productData?.urlKey
        data = {
          "price": newPrice,
          "url": url,
          "product": productData?.product_id,
          "receivedFrom": receivedFrom
        }
      }
      else {
        data = {
          "price": newPrice,
          "product": productData?.product_id,
          "receivedFrom": receivedFrom
        }
      }
      data["lostOrderId"] = productData?._id
      const res = await api.transferprice.priceChangeRquest(data);
      if (res?.message === "price change request submitted" || res?.message === "price request updated") {
        onClose(productData, true);
        alert.success('Price requested successfully!');
      }
      else {
        alert.info(res?.message || 'Error')
      }
    } catch (error) {
      console.error('Error updating price:', error);
      alert.error('Failed to update price');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  if (!isOpen) return null;

  const renderCombination = () => {
    if (productData?.from === "notification") {
      let comb = [];
      let attrs = [];
      try { comb = JSON.parse(productData?.attributeValue || "[]"); } catch { }
      try { attrs = JSON.parse(productData?.attributes || "[]"); } catch { }
      const pairs = attrs.map((item, index) => (
        <span key={index} className="tag pack-tag" style={{ marginRight: "5px" }}>
          {item} - {comb[index]}
        </span>
      ));
      return <>{pairs}</>;
    }
    else if (productData?.foundCombination) {
      const comb = productData.foundCombination;
      const attributes = productData.attributes;

      return attributes?.value?.map((item, index) => (
        <span key={index} className="tag pack-tag" style={{ marginRight: '5px' }}>
          {item} - {comb?.value?.[index]}
        </span>
      ));
    }
    return null;
  };



  return (
    <div className="adjust-price-overlay">
      <div className="adjust-price-modal">
        {/* Header */}
        <div className="modal-header">
          <h3 className="modal-title">Adjust Price</h3>
          <button className="modal-close" onClick={handleCancel}>
            <i className="bi bi-x"></i>
          </button>
        </div>

        {/* Product Details Section */}
        <div className="product-details-section">
          <div className="product-images">
            <div className="main-image">
              <img
                src={"https://s3.toolsvilla.com/" + productData?.image}
                alt={productData?.productName}
              />
            </div>
          </div>

          <div className="product-info">
            <h4 className="product-name">{productData.productName || "N/A"}</h4>
            <p className="product-sku">SKU: {productData.SKU || 'N/A'}</p>
            <div className="product-tags">
              {renderCombination()}

            </div>
          </div>
        </div>

        {/* Price Information Section */}
        <div className="price-info-section">
          <div className="current-price">
            <span className="price-label">Current price :</span>
            <span className="price-value">₹{productData?.currentVendorPurchasePrice || "N/A"}</span>
          </div>
          <div className="price-separator"></div>
          <div className="lowest-price">
            <span className="price-label">Lowest Price:</span>
            <span className="price-value">₹{productData?.lowestPrice || "N/A"}</span>
          </div>
        </div>

        {/* New Price Input Section */}
        <div className="new-price-section">
          <label className="new-price-label">New Price</label>
          <div className="price-input-container">
            <span className="currency-symbol">₹</span>
            <input
              type="number"
              className="adj-price-input  "
              value={newPrice}
              onChange={(e) => {
                if (e.target.value > Number(productData?.vendorPrice)) {
                  alert.info("Price cannot be greater than current price.")
                }
                else {
                  setNewPrice(e.target.value)
                }
              }
              }
              placeholder="Enter new price"
              onWheel={(e) => e.target.blur()}
              min="0"
              onKeyDown={(e) => {
                if (e.key === '.' || e.key === ',' || e.key === "-") {
                  e.preventDefault();
                  alert.info('Not allowed!');
                }
              }}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="modal-actions">
          <button
            className="btn-cancel"
            onClick={handleCancel}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="btn-update"
            onClick={handleUpdatePrice}
            disabled={isLoading || !newPrice}
          >
            {isLoading ? 'Updating...' : `Update Price at ₹ ${newPrice}`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdjustPriceModal;


